export default __webpack_public_path__ + "static/media/Runic Band of Inherent Hatred.0037fe99.jpg";